<template>
  <div class="public_bg">
    <div class="nurse_top">
      <div style="height:54px;line-height:54px;">
        <img style="vertical-align:middle;" src="@/assets/beadhouse/juxing.png" />
        <span>系统设置管理</span>
      </div>
    </div>
    <div class="row_link clearfix">
      <div class="item" v-for="(item,index) in infoList" :key="index" @click="handleClick(item)">
        <a>
          <img :src="item.img" />
          <h5 style="font-size:16px;">{{item.title}}</h5>
          <span>{{item.text}}</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  name: "doorManagement",
  data() {
    return {
      infoList: [] //数据源
    };
  },
  methods: {
    //点击每个
    handleClick(item) {
      bus.$emit("homePage", {
            type: "jump",
            path: item.url,
            title: item.title
          });
          
    },
    /**
     * 获取菜单栏的数据列表
     */
    getPageData() {
      this.infoList = [
        {
          img:require("@/assets/beadhouse/BuildView.png"),
          title:'机构介绍',
          text:'机构介绍',
          uid:1,
          url:'/GroupInfo'
        },{
          img:require("@/assets/beadhouse/InformationPublish.png"),
          title:'信息发布',
          text:'机构信息发布',
          uid:2,
          url:'/InformationMassagePush'
        },{
          img:require("@/assets/beadhouse/ActivePush.png"),
          title:'活动发布',
          text:'活动发布列表',
          uid:3,
          url:'/ActiveList'
        },{
          img:require("@/assets/beadhouse/Dictionary.png"),
          title:'数据字典',
          text:'数据字典',
          uid:4,
          url:'/Dictionary'
        },{
          img:require("@/assets/beadhouse/hulixiangmu.png"),
          title:'自理等级',
          text:'维护机构自理/护理等级',
          uid:9,
          url:'/LevelCareManage'
        },{
          img:require("@/assets/beadhouse/EvaluationListleyi.png"),
          title:'评估项目管理',
          text:'评估项目管理',
          uid:5,
          url:'/EvaluationList'
        },{
          img:require("@/assets/beadhouse/thresholdvalue.png"),
          title:'机构阈值管理',
          text:'机构设备阈值管理,针对后续设备报警',
          uid:6,
          url:'/GroupThresholdSetting'
        },{
          img:require("@/assets/beadhouse/yule_music.png"),
          title:'娱乐管理',
          text:'娱乐项目管理,包含音视频',
          uid:7,
          url:'/entertainmentManagement'
        },{
          img:require("@/assets/beadhouse/hulixiangmu.png"),
          title:'版本管理',
          text:'网页端版本管理',
          uid:8,
          url:'/VersionInfo'
        }
      ];

    }
  },
  created() {
    this.getPageData();
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.public_bg {
  width: 100%;
  height: 95%;
  padding: 0 0 20px 0;
  background: #fefefe;
  .nurse_top {
    border: 1px #f1eff2 solid;
    background: #f9f7fa;
    position: relative;
    img {
      margin: 14px 12px;
    }
    h5 {
      display: inline-block;
      position: absolute;
      top: 12px;
      font-size: 18px;
    }
  }
  .row_link {
    width: 1259px;

    margin: 34px 35px;
    .item {
      width: 275px;
      height: 99px;
      border: #f0f0f2 1px solid;
      margin-bottom: 34px;
      margin-right: 34px;
      float: left;
      cursor: pointer;
      img {
        float: left;
        margin: 8px 23px 8px 33px;
        margin-right: 16px;
      }
      span {
        color: #666666;
      }
      h5 {
        margin-top: 21px;
        margin-bottom: 8px;
      }
      a:hover {
        color: #333;
      }
    }
    .item:hover {
      border: 1px solid red;
    }
  }
}
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
}
.clearfix {
  *zoom: 1;
}
</style>
